import React from "react";

import { AlertTriangle, ChevronRight, X } from "lucide-react";

interface IWarning {
    team: string;
    title: string;
    description: string;
    time: string;
    change: number;
    changePositive: boolean;
    risk: 'high' | 'medium' | 'low';
    riskText: string;
    rightSub: string;
    rightPillText: string;
};
export const Warnings = () => {

    const warnings: IWarning[] = [
        {
            team: 'Sales',
            title: 'Impulsivity',
            description: `<p class="text-sm color--txt-secondary"><strong class="color--txt-tertiary">Lure Susceptibility:</strong> End-of-month target pressure may increase the "Saving Time" marker. Users are currently bypassing lead verification to prioritize speed over safety.</p>`,
            time: 'Oct-Dec',
            change: 15.3,
            changePositive: false,
            risk: 'high',
            riskText: 'Critical Risk',
            rightSub: 'IMMEDIATE THREAT',
            rightPillText: 'Lead-Gen Phishing',
        },
        {
            team: 'Finance',
            title: 'Bandwidth',
            description: `<p class="text-sm color--txt-secondary"><strong class="color--txt-tertiary">Cognitive Load Warning:</strong> High audit volume may deplete the "Attention" battery. Increased vulnerability to Authority-driven spoofed invoices detected.</p>`,
            time: 'Oct-Dec',
            change: 8.7,
            changePositive: false,
            risk: 'medium',
            riskText: 'Elevated Risk',
            rightSub: 'PRIMARY VECTOR',
            rightPillText: 'BEC/Wire Fraud',
        },
        {
            team: 'Engineering',
            title: 'Compliance',
            description: `<p class="text-sm color--txt-secondary"><strong class="color--txt-tertiary">Efficiency Drift:</strong> Use of unvetted Ai coding assistants may result in drop in policy compliance. Rationalization bias (Dunning-Kruger) is high.</p>`,
            time: 'Oct-Dec',
            change: 4.2,
            changePositive: true,
            risk: 'low',
            riskText: 'Stable Monitor',
            rightSub: 'LATENT THREAT',
            rightPillText: 'Shadow IT/Data Leak',
        },
    ];

    return (
        <div className='dashboard__mcsa__warnings'>
            {warnings.map(warning => (
                <div key={warning.title} className={`dashboard__mcsa__warnings__card dashboard__mcsa__warnings__card--${warning.risk}`}>
                    <div className='dashboard__mcsa__warnings__card__left'>
                        <AlertTriangle />
                    </div>
                    <div className='dashboard__mcsa__warnings__card__middle'>
                        <div className='d-flex gap-sm'>
                            <p className='text-semibold mb-xs'>{warning.team} • {warning.title}</p>
                            <div className='dashboard__mcsa__warnings__card__risk_pill'><p className='text-xs text-medium'>{warning.riskText.toUpperCase()}</p></div>
                        </div>
                        <div className='mb-sm' dangerouslySetInnerHTML={{ __html: warning.description }}></div>
                        <p className='text-xs color--txt-muted'>
                            <span>{warning.time}</span>
                            <span className='pl-lg'>Change: </span>
                            <span className={`color--${warning.changePositive ? 'success' : 'error'}`}>{warning.changePositive ? '-' : '+'}{warning.change}%</span>
                        </p>
                    </div>
                    <div className='dashboard__mcsa__warnings__card__right'>
                        <div className='d-flex flex-column gap-xs align-items-end'>
                            <p className='color--txt-muted text-semibold' style={{ fontSize: '10px', lineHeight: '1' }}>{warning.rightSub}</p>
                            <div className='dashboard__mcsa__warnings__card__right__pill'><p className='text-xs text-semibold'>{warning.rightPillText}</p></div>
                        </div>
                        <div className='d-flex gap-sm'>
                            <button className='btn btn--icon-sm btn--radius-sm btn--secondary'>
                                <ChevronRight />
                            </button>
                            <button className='btn btn--icon-sm btn--radius-sm btn--secondary'>
                                <X />
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};